// extracted by mini-css-extract-plugin
module.exports = {"root":"_8854f6a6","isVariantPrimary":"_51769d87","item":"_5c078120","isVariantSecondary":"_b85b4a52"};